import { Role } from '../interfaces'

export const isRole = (value: string): value is Role => Object.keys(Role).includes(value as Role)
